// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"496":"graphql-print","557":"f10664bc"}[chunkId] || chunkId) + "." + {"5":"46a442f6a83e4a1b","261":"96e48d5443b839a4","496":"83edc8afc0370428","557":"56bba4a3c518b52e"}[chunkId] + ".js";
};